const indexItems = [
  {
    title: '电影大全',
    icon: 'ri-film-line',
    desc: '动作、喜剧、爱情、科幻、悬疑……万部电影随心选',
    count: '12,000+',
  },
  {
    title: '电视剧库',
    icon: 'ri-tv-line',
    desc: '国产剧、韩剧、美剧、日剧，热门剧集一网打尽',
    count: '5,800+',
  },
  {
    title: '综艺合集',
    icon: 'ri-emotion-laugh-line',
    desc: '音乐、选秀、脱口秀、真人秀，轻松解压好选择',
    count: '2,400+',
  },
  {
    title: '动漫天地',
    icon: 'ri-ghost-line',
    desc: '日漫、国漫、剧场版，二次元世界触手可及',
    count: '3,600+',
  },
  {
    title: '纪录片库',
    icon: 'ri-earth-line',
    desc: '自然、历史、科技、人文，用镜头探索世界',
    count: '1,500+',
  },
  {
    title: '经典怀旧',
    icon: 'ri-history-line',
    desc: '黄金年代经典作品，重温那些难忘的光影记忆',
    count: '800+',
  },
  {
    title: '儿童专区',
    icon: 'ri-parent-line',
    desc: '动画电影、亲子节目，适合全家一起看的优质内容',
    count: '2,000+',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按类型快速浏览，精准找到你想看的每一部好作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.slice(0, 1).map((item, idx) => (
            <div
              key={idx}
              className="lg:col-span-2 bg-background-50 rounded-lg p-5 md:p-6 flex items-center gap-5 cursor-pointer hover:bg-background-200/50 transition-colors"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-accent-100 shrink-0">
                <i className={`${item.icon} text-accent-500 text-2xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <span className="text-xs font-medium text-accent-500 whitespace-nowrap">
                    {item.count} 部
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600">{item.desc}</p>
              </div>
            </div>
          ))}

          {indexItems.slice(1).map((item, idx) => (
            <div
              key={idx + 1}
              className="bg-background-50 rounded-lg p-5 cursor-pointer hover:bg-background-200/50 transition-colors"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 mb-3">
                <i className={`${item.icon} text-secondary-500 text-xl`}></i>
              </div>
              <div className="flex items-center justify-between mb-1.5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <span className="text-xs font-medium text-secondary-500 whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}